<label class="import-layer">
	<input type="file"
		   accept=".kml, .geojson, .json, .KML, .JSON, .GEOJSON, .shp"
		   (change)="importLayer($event.target.files)"/>
	<i class="icon-layer-import"></i>
</label>
